import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import { FaClipboardList, FaRegEye, FaLock } from "react-icons/fa";
import { hasPermission } from "../../hooks/usePermission";
import { getRole } from "../../utils/role";
import { handleReportNavigation } from "../../utils/mobileNavigation";

function UserReportsTable({ reports }) {
  const navigate = useNavigate();
  const role = getRole();

  const canFollowup = hasPermission('reports:followup');

  const getRecords = () => {
    return reports.map((report, index) => (
      <tr key={report?.report_id}>
        <td data-label="S. NO.">{index + 1}</td>
        <td data-label="REPORT ID">{report.report_id}</td>
        <td data-label="SAMPLE ID">{report.sample_id?.toUpperCase()}</td>
        <td data-label="FARM NAME">{report.farm_name?.toUpperCase()}</td>
        <td data-label="FARM SIZE">
          {report.farm_size?.toUpperCase()}&nbsp;
          {report.farm_size_unit?.toUpperCase()}
        </td>
        <td data-label="PREVOIUS CROP">{report.previous_crop?.toUpperCase()}</td>
        <td data-label="NEXT CROP">{report.next_crop?.toUpperCase()}</td>
        <td data-label="DATE">
          {new Date(Date.parse(report.created_at)).toDateString()}
        </td>

        <td data-label="View">
          {role === 'FIELD_OFFICER' && report.is_locked ? (
             <div className="d-flex justify-content-center">
                <FaLock color='red' size={20} title="Report is locked" />
             </div>
          ) : (
            <Button
                variant={role === 'FIELD_OFFICER' ? "warning" : "success"}
                size="sm"
                onClick={() => {
                    const path = role === 'FIELD_OFFICER' 
                        ? `/reports/${report.report_id}`
                        : `/users/report/${report.report_id}`;
                    handleReportNavigation(navigate, path);
                }}
            >
                <div className="d-flex justify-content-center align-items-center">
                {role !== 'FIELD_OFFICER' && <FaRegEye size={16} className="me-1" />}
                {role === 'FIELD_OFFICER' ? 'View' : 'Continue'}
                </div>
            </Button>
          )}
        </td>

        {/* --- GENERIC FOLLOW UP (Support) --- */}
        {canFollowup && (
          <td data-label="FOLLOW UP">
            {report.sample_type?.toUpperCase() === 'SOIL' && (
              <Button
                variant="primary"
                size="sm"
                onClick={() => navigate(`/reports/${report.report_id}/follow-ups`)}
              >
                <div className="d-flex justify-content-center align-items-center">
                  <FaClipboardList size={16} className="me-1" />
                  <span>Follow Up</span>
                </div>
              </Button>
            )}
          </td>
        )}

        {/* --- TRACK PROGRESS (Support) --- */}
        {hasPermission('reports:track') && (
            <td data-label="Track progress">
            <Button
                variant="warning"
                size="sm"
                onClick={() => navigate(`/report-progress/${report.report_id}`)}
            >
                Track
            </Button>
            </td>
        )}
      </tr>
    ));
  };

  return (
    <div className="table-responsive">
        <table className={`table table-striped text-center table-borderless align-middle`}>
        <thead className="table-dark align-top">
            <tr>
            <th>S. NO.</th>
            <th>REPORT ID</th>
            <th>SAMPLE ID</th>
            <th>FARM NAME</th>
            <th>FARM SIZE</th>
            <th>PREVIOUS CROP</th>
            <th>NEXT CROP</th>
            <th>DATE</th>
            <th>VIEW</th>
            
            {canFollowup && <th>FOLLOW UP</th>}
            {hasPermission('reports:track') && <th>TRACK PROGRESS</th>}
            </tr>
        </thead>
        <tbody>
            {reports && reports.length > 0 ? (
            getRecords()
            ) : (
            <tr>
                <td className="no-entries" colSpan="15">
                No Entries Found..
                </td>
            </tr>
            )}
        </tbody>
        </table>
    </div>
  );
}

export default UserReportsTable;